import API from '../api.js'
import DataProcessor from '@lib/processors/data-processor'
import { formatDate } from '@lib/utils/format-date'

class ApiProcessor extends DataProcessor {
  constructor(params = {}) {
    const { path, headers, transformData } = params
    super(params)

    if (typeof path !== 'string' || path.length === 0) {
      throw Error('api-processor requires "path" key')
    }

    this.path = path
    this.headers = headers || null
    this.transformData = transformData
    this.init()
  }

  destroy() {
    super.destroy()
  }

  getSortMap({ sort }) {
    const sortMap = {} // 'order[propName]: asc|desc'

    for (const key in sort) {
      if (sort.hasOwnProperty(key)) {
        sortMap[`order[${key}]`] = sort[key]
      }
    }

    return sortMap
  }

  getFiltersMap({ filters }) {
    return filters.reduce((acc, incomingFilters) => {
      const { attribute, comparison, type, value } = incomingFilters

      if (comparison !== 'eq') {
        switch (type) {
          case 'numeric':
            return { ...acc, [`${attribute}[${comparison}]`]: value }
          case 'date':
            // NOTE: correct timezone offset
            return { ...acc,
              [`${attribute}[${comparison}]`]: formatDate(`${value}`, {
                format: 'YYYY-MM-DD',
                useUTC: true,
              }) }
        }
      }

      return { ...acc, [attribute]: value }
    }, {})
  }

  sendRequest(dataQuery) {
    const { page, pageSize } = dataQuery

    const params = {
      page,
      perPage: pageSize,
      ...this.getSortMap(dataQuery),
      ...this.getFiltersMap(dataQuery),
    }

    return API.get(this.path, {
      params,
      headers: this.headers,
    }).then(([_, data]) => {
      const { items, pagination } = data

      if (this.transformData) {
        const transformed = this.transformData(items)
        return {
          data: transformed,
          total: transformed.length,
        }
      } else {
        return {
          data: items,
          total: pagination.total_items,
        }
      }
    })
  }

  sendRequestAll(dataQuery) {
    const params = {
      page: 1,
      perPage: 1e9,
      ...this.getSortMap(dataQuery),
      ...this.getFiltersMap(dataQuery),
    }

    return API.get(this.path, {
      params,
      headers: this.headers,
    }).then(([_, data]) => {
      const { items, pagination } = data

      return {
        data: items,
        total: pagination.total_items,
      }
    })
  }
}

export default ApiProcessor
